import React from 'react'
// libs
import styled from 'styled-components'
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import { ReduxDatePicker, ReduxEntitySelect } from 'components/FormElements'
// constants
import { Forms } from 'constants/forms'
import { IOption } from 'components/FormElements/Select'
// graphql
import { USERS_SELECT_QUERY } from 'graphql/user/queries'
// utils
import { userProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

const Form = styled.form`
  display: flex;
  gap: 20px;
  padding: 20px;

  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.04),
    0 14px 30px rgba(0, 0, 0, 0.04);

  > div {
    width: 100%;
    max-width: 240px;
  }
`

interface FormData {
  startPeriod?: string
  endPeriod?: string
  user?: IOption
}

const Filter: React.FC<InjectedFormProps<FormData>> = ({ handleSubmit }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <ReduxDatePicker label='Start of reporting period' name='startPeriod' clearable />
      <ReduxDatePicker label='End of reporting period' name='endPeriod' clearable />
      <ReduxEntitySelect name='user' label='User' query={USERS_SELECT_QUERY} {...userProps} isClearable />
    </Form>
  )
}

export default reduxForm<FormData, any>({ form: Forms.AI_USAGE_FILTER_FORM })(Filter)
